import React, { useState } from "react"

import { interfaces } from "service/interfaces"
import DialogComponent from "Components/UI/Molecules/Modals/DialogComponent"
import useCustomSnackbar from "Components/UI/Atoms/SnackBar"
import CancelConfirmButtons from "Components/UI/Molecules/CancelConfirmButtons"

const Delete = (props) => {
  const { open, handleClose, idLocalities, changeRender, setDataLocalities } =
    props

  const [loading, setLoading] = useState(false)

  const createDismissableSnackbar = useCustomSnackbar()

  const onSubmit = () => {
    setLoading(true)
    interfaces.configInterface
      .deleteLocalities(idLocalities)
      .then((res) => {
        setDataLocalities(prevData => {
          return prevData.filter(locality => locality.id !== idLocalities)
        })
        createDismissableSnackbar(res.data, {
          variant: "success",
        })
        changeRender()
        handleClose()
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data.data, {
          variant: "error",
        })
      })
      .finally(() => {
        setLoading(false)
        handleClose()
      })
  }

  return (
    <div>
      <DialogComponent
        open={open}
        handleclose={handleClose}
        widthLarge="500px"
        title="¿Desea eliminar esta localidad?"
        disableChildHeight
        disableBackdropClick
        disableEscapeKeyDown
        actions={
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <CancelConfirmButtons
              onClickCancel={handleClose}
              onClickSubmit={onSubmit}
              disabledCancel={loading}
              disabledSubmit={loading}
              isLoading={loading}
            />
          </div>
        }
      />
    </div>
  )
}

export default Delete
